import React from "react";

import { PineScriptCodeBlock } from "./PineScriptCodeBlock";
import { DEFAULT_MIN_SCRAMBLE_MS } from "./usePineScriptScramble";

export type PineScriptScrambleRevealProps = {
  /** True while waiting for / fetching composed script text. */
  waitingForCode: boolean;
  /** Final Pinescript; reveal starts when this becomes non-empty. */
  code?: string;
  maxH?: string;
  /** When false, render body only (legacy; prefer PineScriptCodeBlock scramble). */
  showChrome?: boolean;
  brandChrome?: boolean;
  chromeTitle?: string;
  chromeSubtitle?: string;
  /** Minimum time to show scramble before starting reveal, even if code arrives sooner. */
  minScrambleMs?: number;
  onRevealComplete?: () => void;
  /** Stable key for a new compose session (e.g. compose sequence). */
  sessionKey?: string | number;
};

export function PineScriptScrambleReveal({
  waitingForCode,
  code = "",
  maxH = "min(280px, 38vh)",
  showChrome = true,
  brandChrome = true,
  chromeTitle = "Pinescript",
  chromeSubtitle,
  minScrambleMs = DEFAULT_MIN_SCRAMBLE_MS,
  onRevealComplete,
  sessionKey,
}: PineScriptScrambleRevealProps): React.ReactElement {
  const subtitle =
    chromeSubtitle ?? (waitingForCode ? "Composing…" : "Generated code");

  return (
    <PineScriptCodeBlock
      code={code}
      maxH={maxH}
      brandChrome={brandChrome && showChrome}
      chromeTitle={chromeTitle}
      chromeSubtitle={subtitle}
      scramble={{
        enabled: true,
        waitingForCode,
        minScrambleMs,
        onRevealComplete,
        sessionKey,
      }}
    />
  );
}
